import initialListState from 'store/hoReducers/paginatedList/initialState';
import RULES_FILTER_OPTIONS from 'constants/rulesOptions';

const initialState = {
  ...initialListState,
  all: {
    isLoading: false,
    error: '',
    data: [],
    count: 0,
  },
  list: {
    ...initialListState.list,
    filterOptions: RULES_FILTER_OPTIONS,
    filterParams: {},
    paginationOptions: {
      page: 1,
      size: 30,
      search: '',
      ordering: '-created_at',
      archived: '',
    },
    totalCount: 0, // totalCount is different from list.data.count and ignores the filters
  },
  reorder: {
    isLoading: false,
    error: '',
  },
  partialUpdate: {
    isLoading: false,
    error: '',
  },
  full: {
    isLoading: false,
    error: '',
    data: [],
  },
};

export default initialState;
